const defaultConfig = {
  navigation: {
    mini: false
  },
  taskName: undefined,
  businessName: undefined,
  notLatestVersion: false,
  oldLastRun: false
};

class GlobalConfigClass {
  /**
   *
   * @param {object} config
   */
  constructor(config) {
    this.config = Object.assign({}, defaultConfig, config);
  }
}

export const GlobalConfig = new GlobalConfigClass();
